import Vue from 'vue';

import { ExperimentEngagementService } from '@superbet-group/web.lib.experiment-engagement-service';
import { ActionContext } from 'vuex';
import { getShellConfig } from '@src/config/shell/config';

const SET_EXPERIMENT_SERVICE = 'SET_EXPERIMENT_SERVICE';
const SET_IS_LOADING = 'SET_IS_LOADING';

export type ExperimentState = {
    isLoading: boolean;
    experimentService: ExperimentEngagementService | null;
};

const getDefaultState = (): ExperimentState => ({
    isLoading: true,
    experimentService: null,
});

const experimentStore = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        [SET_EXPERIMENT_SERVICE](state: ExperimentState, service: ExperimentEngagementService) {
            Vue.set(state, 'experimentService', service);
        },
        [SET_IS_LOADING](state: ExperimentState, isLoading: boolean) {
            Vue.set(state, 'isLoading', isLoading);
        },
    },
    actions: {
        initialize: (context: ActionContext<ExperimentState, any>) => {
            const shellConfig = getShellConfig();
            const apiUrl = shellConfig.remoteConfig.experiment.apiUrl;

            if (!apiUrl) {
                console.error('Experimentation service API URL is not defined in the shell config.');
                return;
            }

            const service = new ExperimentEngagementService(apiUrl);
            context.commit(SET_EXPERIMENT_SERVICE, service);
        },
        setIsLoading: (context: ActionContext<ExperimentState, any>, isLoading: boolean) => {
            context.commit(SET_IS_LOADING, isLoading);
        },
    },
    getters: {
        experimentService: (state: ExperimentState): ExperimentEngagementService | null => state.experimentService,
        isLoading: (state: ExperimentState): boolean => state.isLoading,
    },
};

export default experimentStore;

type ExperimentStore = typeof experimentStore;

export {
    ExperimentStore,
};
